/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext, useContext } from 'react';
import { UserInfo, UserRole } from '../components/admin/namespace/types';

export interface UserContextProps {
	user: UserInfo;
	userRoles: UserRole[];
	selectedUserRole: UserRole;
	activeRole: string;
	setSelectedUserRole: (user: UserRole) => void;
	changeRole: () => void;
}

const UserContext = createContext<UserContextProps>({
	user: null,
	userRoles: [],
	selectedUserRole: null,
	activeRole: null,
	setSelectedUserRole: () => {},
	changeRole: () => {},
});

export const UserProvider = UserContext.Provider;

export const useUserContext = () => {
	return useContext(UserContext);
};

export default UserContext;
